<mat-form-field #dynamicWidth fxFlex="0 0 100%" appearance="outline" class="dhl-borderless-field" [formGroup]="frmGroup" color="accent">
    <div style="margin-bottom: 10px;">
        <mat-label class="dhl-config-data-label">{{ configData.label }}</mat-label>    
    </div>
    <textarea matInput hidden></textarea>
    <mat-button-toggle-group *ngIf="configData.screenVersion === 'v2';" class="border-0 button-style toggle-button-group"
        [required]="configData.required" multiple [formControlName]="configData.name">
        <mat-button-toggle style="padding: 0px;" class="button-margin rectangle toggle-button-width"
            [ngStyle]="{'width' : ((dynamicWidthValue-32)/toggleOptions.length)+'px'}" *ngFor="let button of toggleOptions"
            [value]="button.value">
            <div class="Combined-Shape">
                <img [src]="frmGroup.get($safeNavigationMigration(configData?.name))?.value?.includes($safeNavigationMigration(button?.value)) ? button.imageOnActive : button.image"
                    class="iconstruckstrucksload">
            </div>
            <div class="label-empty">
                {{button.displayValue}}
            </div>
        </mat-button-toggle>
        <!-- <div ><img src= {{button.image}} width="50px"></div>{{button.displayValue}}</mat-button-toggle> -->
    </mat-button-toggle-group>

    <mat-button-toggle-group *ngIf="configData.screenVersion !== 'v2'" [required]="configData.required"  multiple [formControlName]="configData.name">
        <mat-button-toggle *ngFor="let button of toggleOptions" [value]="button.value">{{button.displayValue}}</mat-button-toggle>
    </mat-button-toggle-group> 
    <!-- <span style="margin-left: 100px;font-size: 25px;"><b>200%</b></span> -->
    <mat-error *ngIf="frmGroup.get(configData.name).errors">
        <mat-error *ngIf="frmGroup.get(configData.name).errors.required">
            Required
            <!-- {{frmGroup.get(configData.name).errors | json}} -->
        </mat-error>
        <div class="form-field-error" *ngIf="frmGroup.get(configData.name).errors">
            <span class="error-icon">
                <img class="dhl-input-error-icon" src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
            </span>
            <span class="error-text" *ngIf="frmGroup.get(configData.name).errors?.groupValidationError">
                {{ $safeNavigationMigration(frmGroup.get(configData.name).errors?.groupValidationError) | translate }}
            </span>
        </div>
    </mat-error>
</mat-form-field>
